import { GraphQLScalarType } from "graphql"

export const GatsbyImageDataScalar = new GraphQLScalarType({
  name: `GatsbyImageData`,
})
